module.exports = __webpack_public_path__ + "img/pic_banner_museum.70dc737f.png";